import React from "react";
import { Box, Button } from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function toISO(d){
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,"0");
  const dd = String(d.getDate()).padStart(2,"0");
  return `${y}-${m}-${dd}`;
}

export default function DateRangeBar({ from, to, onChange }){
  const fromDate = new Date(from+"T00:00:00");
  const toDate = new Date(to+"T00:00:00");

  const setFrom = (d)=> onChange({from: toISO(d), to});
  const setTo = (d)=> onChange({from, to: toISO(d)});

  const quick = (days)=>{
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate()-days);
    onChange({from: toISO(start), to: toISO(end)});
  };

  return (
    <Box display="flex" alignItems="center" gridGap={12} flexWrap="wrap">
      <Box>
        <div style={{fontSize:12, opacity:.7, marginBottom:4}}>Desde</div>
        <DatePicker
          selected={fromDate}
          onChange={setFrom}
          dateFormat="yyyy-MM-dd"
        />
      </Box>
      <Box>
        <div style={{fontSize:12, opacity:.7, marginBottom:4}}>Hasta</div>
        <DatePicker
          selected={toDate}
          onChange={setTo}
          dateFormat="yyyy-MM-dd"
        />
      </Box>

      <Box display="flex" gridGap={8}>
        <Button variant="outlined" size="small" onClick={()=>quick(0)}>Hoy</Button>
        <Button variant="outlined" size="small" onClick={()=>quick(7)}>7 días</Button>
        <Button variant="outlined" size="small" onClick={()=>quick(30)}>30 días</Button>
      </Box>
    </Box>
  );
}
